import { render, staticRenderFns } from "./topupModel.vue?vue&type=template&id=1a5aed0b&scoped=true"
import script from "./topupModel.vue?vue&type=script&lang=js"
export * from "./topupModel.vue?vue&type=script&lang=js"
import style0 from "./topupModel.vue?vue&type=style&index=0&id=1a5aed0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5aed0b",
  null
  
)

export default component.exports